import { Controller } from "@hotwired/stimulus";
import moment from "moment-timezone";
import { localTZ } from "../lib/date_helpers";

export default class extends Controller {
  static values = {
    epoch: Number,
    refreshInterval: Number,
    format: String,
  };

  get time() {
    const time = moment.unix(this.epochValue);
    const cookieZone = document.cookie.match(/timezone=(.*?)(;|$)/);
    if (cookieZone) {
      return time.tz(cookieZone[1]);
    }

    return time.tz(localTZ());
  }

  connect() {
    this.render();
    if (this.hasRefreshIntervalValue) {
      this.refreshInterval = window.setInterval(
        () => this.render(),
        this.refreshIntervalValue * 1000,
      );
    }
  }

  disconnect() {
    if (this.refreshInterval) {
      window.clearInterval(this.refreshInterval);
    }
  }

  formattedTime() {
    switch (this.formatValue) {
      case "relative-without-suffix":
        return this.time.fromNow(true);
      case "relative":
        return this.time.fromNow();
      default:
        return this.time.format("LLL");
    }
  }

  render() {
    this.element.innerHTML = this.formattedTime();
  }
}
